import axios from 'axios'
import { API_ENDPOINT } from '../../tools/apiEndpoint'

// 読み取る書類の種類
export const ocrDocType = {
  vehicleInspection: 'vehicleInspection'
}

/**
 * AI-OCR の読み取りを受け付ける
 * POST /ocr/jobs
 * @param {object} params
 * @param {File} params.file - 読み取る PDF
 * @param {string} params.docType - 書類の種類（ocrDocType）
 * @returns {Promise} { jobId }
 */
export const createOcrJobApi = async ({ file, docType }) => {
  const URL = `${API_ENDPOINT}/ocr/jobs`
  const config = {
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
  }
  const formData = new FormData()
  formData.append('file', file)
  formData.append('docType', docType)
  return axios.post(URL, formData, config)
}

/**
 * AI-OCR の読み取り状況を取得する
 * GET /ocr/jobs/:jobId
 * @param {object} params
 * @param {string} params.jobId - 受付番号
 * @returns {Promise} { status: 'PENDING' | 'COMPLETED' | 'FAILED', values?, reason? }
 */
export const getOcrJobApi = async ({ jobId }) => {
  const URL = `${API_ENDPOINT}/ocr/jobs/${jobId}`
  const config = {
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
  }
  return axios.get(URL, config)
}
